<script>
    import appConfig from "../../../app.config";
    import "swiper/swiper-bundle.css";
    import axios from 'axios';
    // import animationData from "@/components/widgets/lupuorrc.json";
    // import Lottie from "@/components/widgets/lottie.vue";


    // this.$route.params.hash
    export default {
        page: {
            title: "Starter",
            meta: [{
                name: "description",
                content: appConfig.description
            }],
        },
        data() {
            return {
                title: "Starter",
                items: [{
                        text: "Pages",
                        href: "/",
                    },
                    {
                        text: "Starter",
                        active: true,
                    },
                ],
                status:'',


            };
        },



        methods: {
            getCustomer(){
                axios.get(process.env.VUE_APP_API_BASEURL+'check/curlect/'+this.$route.params.id+'/'+this.$route.params.hash)
                .then(response => {
                    if (response) {
                        window.location.href=response.data.url;

                        // console.log(this.dataCustomer);                
                    } else {
                        this.messageBag = ['No record.'];
                        this.OrderSeen = false;
                    }
                })
                    .catch(error => {
                        this.messageBag = [error.error];
                        this.OrderSeen = false;
                });
            },
        },

        
        components: {
            // lottie: Lottie

        },
        mounted(){
            this.getCustomer();
        }
    };
</script>

<style >
    #container{
    padding-top:20px;
    margin-top:20px;
    width:100vw;
    color:white;
    background-color:#003E30;
    display:flex;
    flex-direction:column;
    align-items:center;
    position:fixed;
    bottom:0;
    }
    #contacts{
    display:flex;
    justify-content:space-around;
    align-items:center;
    width:100%;
    }
    #contacts--contact{
    text-align:right;
    }
    #contacts--social{
    width:20%;
    display : flex;
    justify-content : space-between;
    }
    #contacts--social div{
    height:30px;
    width:30px;
    background-color:white;
    border-radius:50%;
    }
    #mentions p {
    font-size:0.5em;
    }
    .card {
    margin-bottom: -9.5rem !important;
    }
    /* .progress-nav .progress {
        position: absolute;
        left: 0;
        top: 50%;
        transform: rotate(-90deg);
        width: 100%;
    }    
        
    .progress-nav .nav {
        margin-right: -1rem;
        margin-left: -1rem;
        justify-content: space-between;
        transform: rotate(90deg);
    }
        
    .progress-nav .nav .nav-link {
        width: 2rem;
        height: 2rem;
        background-color: var(--vz-light);
        padding: 0;
        color: var(--vz-dark);
        font-weight: 400;
        transform: rotate(-90deg);
    } */
 
    @media (min-width: 1025px) and (max-width: 2399px){
           
        .progress-nav .progress {
            position: absolute;
            left: -86%;
            top: 54%;
            width: 173%;
            transform: rotate(90deg);
            /* background-color: #77BF4C !important;*/
        }
    }

    @media (min-width: 2400px) and (max-width: 3399px){
           
           .progress-nav .progress {
            position: absolute;
            left: -42.5%;
            top: 60%;
            width: 85%;
            transform: rotate(90deg);
            /* background-color: #77BF4C !important;*/
           }
       }
        

    .tabinfo{
        font-size: 16px;
        white-space: nowrap;
        margin-top: 5px;
        padding-left: 5px;
    }
    .fixed-top {
        background-color: #F3F4F6 !important;
    }
    .navbar {
    padding-top: 0px !important;
    /* padding-bottom: 0px !important; */
    }
    .container-fluid{
    padding-right: 0px !important;
    padding-left: 0px !important;
    }
    .progress-nav .nav .nav-link.active, .progress-nav .nav .nav-link.done {
    background-color: #77BF4C !important;
    }
    .progress-bar {
        background-color: #77BF4C !important;
    }
    .pt-tab {
    padding-top: 7rem;
    }
    .btn-primary:hover {
        color: #fff;
        background-color: #77BF4C;
        border-color: #77BF4C;
    }
    .btn {
        color: #fff;
        background-color: #77BF4C !important;
        border-color: #77BF4C !important;
    }
    .form-check-input:checked {
        background-color: #77bf4c !important;
        border-color: #77bf4c !important;
    }
</style>

<template>
    <div class="layout-wrapper landing">

        <nav class="navbar navbar-expand-lg fixed-top" id="navbar">
            <div class="container">
                <a class="navbar-brand" href="index.html">
                    <img style="width: 95px" src="https://renewp.compasia.com/assets/images/logo.png" class="img-fluid card-logo card-logo-dark" alt="logo dark" >
                    <img src="https://renewp.compasia.com/assets/images/logo.png" class="card-logo card-logo-light" alt="logo light" >
                </a>
            </div>
        </nav>

        <section class="section pb-0 hero-section" id="hero" >
        <!-- start hero section -->
            <div class="bg-overlay bg-overlay-pattern"></div>
            <div class="text-center mt-5">

                <!-- <h3>Successful authorization !</h3>
                <h5>RM1.00 pre-authorization fee has been successfully</h5>
                <h5>deducted from your account</h5> -->

            </div>


                    
            <div id="container">
                        <div id="contacts">
                        <div id="contacts--contact">
                            <div>{{ new Date().getFullYear()  }} &copy; CompAsia</div>
                        </div>
                        <div >
                            <div></div>
                            <div></div>
                            <div>Design & Develop by Compasia IT</div>
                        </div>
                        </div>
                        <div id="mentions">
                        <p></p>
                        </div>
            </div>
        </section>
    </div>
    
</template>